<template>
    <div class="exclusive-rights">
        <h4 class="title">专属特权</h4>
        <div class="cont-box">
            <div
                :class="['item-box', {'lock-state': item.isLock}]"
                v-for="(item, index) in data" :key="index"
                @click="rightsClick(item)">
                <div class="img-box">
                    <img class="img-right"
                        :src="item.isLock ? item.greyIcon : item.icon" alt="">
                    <img v-if="item.isLock" class="lock-box" src="//file.40017.cn/appresource/image/forStudent/new/icon_lock@2x.png" >
                    </div>
                <p class="txt">{{item.title}}</p>
                <p class="desc">{{ item.subTitle }}</p>
            </div>
        </div>
    </div>
</template>

<script>
import {  Toast, Icon } from 'vant';
import { toPage, randomString } from "@/utils/tools";

export default {
    name: 'exclusiveRights',
    props: {
        data: {
            type: Array,
            default: () => []
        },
        isAuth: { // 是否学生认证
            type: Boolean,
            default: false
        },
        isChsiAuth: { // 是否学信网认证
            type: Boolean,
            default: false
        },
    },
    components: {
        [Icon.name]: Icon,
    },
    data() {
        return {
            rightList: [
                {
                    icon: 'https://file.40017.cn/appresource/image/forStudent/new/bg_header@2x.png',
                    title: '机火单单返现',
                    subTitle: '最高返40元'
                },{
                    icon: 'https://file.40017.cn/appresource/image/forStudent/new/bg_header@2x.png',
                    title: '千元出行学生卡',
                    subTitle: '最高返40元'
                },{
                    icon: 'https://file.40017.cn/appresource/image/forStudent/new/bg_header@2x.png',
                    title: '出行省钱学生卡',
                    subTitle: '最高返40元'
                },{
                    icon: 'https://file.40017.cn/appresource/image/forStudent/new/bg_header@2x.png',
                    title: '机酒火学生价',
                    subTitle: '最高返40元'
                },{
                    icon: 'https://file.40017.cn/appresource/image/forStudent/new/bg_header@2x.png',
                    title: '机火单单返现',
                    subTitle: '最高返40元'
                },{
                    icon: 'https://file.40017.cn/appresource/image/forStudent/new/bg_header@2x.png',
                    title: '机学生价',
                    subTitle: '最高返40元'
                },{
                    icon: 'https://file.40017.cn/appresource/image/forStudent/new/bg_header@2x.png',
                    title: '机现',
                    subTitle: '最高返40元'
                }
            ]
        }
    },
    mounted() {
        console.log('权益列表', this.data)
        if (this.data.length > 0) {
            let rightNames = []
            this.data && this.data.forEach((i)=> {
                rightNames.push(i.title)
            })
            this.$emit('setTrack', {
                action: 'students_rights_show',
                label: '学生会员权益曝光',
                value: {"channel":"学生专区","scene":"公共","rights": rightNames}
            })
        }
    },
    methods: {
        rightsClick(right) {
            console.log('权益点击1231235435', right)
            if (+right.interactionType === 1) { // 交互类型：1:浮层,2:跳转,3:无
                this.$emit('showDetail', right)
                this.$emit('setTrack', {
                    action: 'students_rightsfloat_show',
                    label: '学生会员权益浮层曝光',
                    value: {"channel":"学生专区","scene":"公共","rights": right.title}
                })
            } else if (+right.interactionType === 2) {
                toPage(right.url)
            } else if (+right.interactionType === 3) {
            }
            this.$emit('setTrack', {
                action: 'students_rights_click',
                label: '学生会员权益点击',
                value: {"channel":"学生专区","scene":"公共","rights": right.title}
            })
        }
    }
}
</script>

<style lang="less" scoped>
.exclusive-rights {
    border-radius: 8px;
    background: #fff;
    margin:12px;
    padding: 12px 12px 0;
    .title {
        font-weight: 500;
        font-size: 16px;
        color: #333333;
    }
    .cont-box {
        // width: 250px;
        display: flex;
        // justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        margin: 12px 0 0;
        color: #333333;
        font-size: 14px;
        line-height: 1.5;
        .item-box {
            width: 81.7px;
            text-align: center;
            margin-bottom: 12px;
            .img-right {
                display: inline-block;
                width: 44px;
                height: 44px;
                border-radius: 22px;
                vertical-align: text-bottom;
            }
            .txt {
                font-size: 12px;
                font-weight: 500;
                color: #333333;
                margin-top: 8px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis
            }
            .desc {
                font-size: 12px;
                color: #888888;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis
            }
            &.lock-state {
                .img-box {
                    position: relative;
                    display: inline-block;
                    .lock-box {
                        position: absolute;
                        bottom: 2px;
                        right: 0;
                        width: 15px;
                        height: 15px;
                    }
                }
                .txt {
                    color: #888888;
                }
                 .desc {
                    color: #B2B2B2;
                }
            }
            
        }
    }
}
</style>>
